<template>
  <section class="section permission-management">
    <b-loading :active="isLoading" />
    <h1 class="title is-size-5 has-text-color-7 has-text-weight-semibold mb-25">
      {{ General.EDIT_PERMISSION }}
    </h1>
    <section :class="{ 'pr-50': !isMobile }">
      <b-field type="is-lighter">
        <template #label>
          <span class="has-text-color-7 has-text-weight-semibold">
            {{ General.PLACEHOLDER.PERMISSION_NAME }}
          </span>
        </template>
        <b-input disabled :placeholder="permission.name" />
      </b-field>

      <b-field>
        <template #label>
          <span class="has-text-color-7 has-text-weight-semibold">
            {{ General.DESCRIPTION }}
          </span>
        </template>
        <b-input
          v-model="permission.description"
          type="textarea"
          :placeholder="General.MESSAGES.EMPTY_DESCRIPTION_PERMISSION"
        />
      </b-field>

      <b-field>
        <template #label>
          <span class="has-text-color-7 has-text-weight-semibold">
            {{ General.PLACEHOLDER.KEYWORDS }}
            <span class="optional-label is-capitalized">
              {{ General.OPTIONAL }}</span
            >
          </span>
        </template>
        <CustomTagInput
          v-model="permission.keywords"
          field="name"
          :data="keywordList"
          allowNew
          autocomplete
          :loading="isFetching"
          :placeholder="General.PLACEHOLDER.INSERT_KEYWORDS"
          @typing="setFilterKeyword"
        >
          <template slot="empty">
            <p>
              {{ General.MESSAGES.NO_RECORDS_FOUND }}
            </p>
          </template>
        </CustomTagInput>
      </b-field>
      <div
        class="buttons"
        :class="{ 'is-flex is-flex-direction-column': isMobile }"
      >
        <b-button
          :type="isContrast ? 'is-white' : 'is-green-lawn'"
          :expanded="isMobile"
          class="has-text-weight-semibold"
          @click="savePermission"
        >
          {{ General.SAVE }}
        </b-button>
        <b-button
          :type="isContrast ? 'is-white' : 'is-orange'"
          :expanded="isMobile"
          class="has-text-weight-semibold"
          outlined
          @click="cancel"
        >
          {{ General.CANCEL }}
        </b-button>
      </div>
    </section>
  </section>
</template>

<script>
import { App, General } from "@/utils/constants";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Permission",

  props: {
    permissionId: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      App,
      General,
      isLoading: false,
      isFetching: false,
      permission: {
        name: "",
        description: "",
        keywords: []
      },
      keywordFilter: ""
    };
  },

  computed: {
    ...mapGetters({
      getAllPermissionsKeywords: "getAllPermissionsKeywords",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),
    keywordList() {
      const regExp = RegExp(this.keywordFilter, "i");
      return this.getAllPermissionsKeywords.filter(
        key => !this.permission.keywords.includes(key) && regExp.test(key)
      );
    }
  },

  async beforeMount() {
    if (this.permissionId) {
      this.requestAllKeywords();
      this.permission = await this.getPermissionRequest(this.permissionId);
      this.permission.keywords = this.permission.keywords || [];
      this.permission.description = this.permission.description || "";
      this.isLoading = false;
    }
  },

  methods: {
    ...mapActions([
      "editPermissionRequest",
      "getPermissionRequest",
      "getAllKeywordRequest"
    ]),
    async savePermission() {
      const { description, keywords } = this.permission;
      if (!description) {
        this.snackToast.open({
          message: `${this.General.MESSAGES.EMPTY_DESCRIPTION_PERMISSION}!`,
          type: "is-danger",
          duration: 8000
        });
        return;
      }
      this.isLoading = true;
      const result = await this.editPermissionRequest({
        permissionId: this.permissionId,
        data: { description, keywords }
      });
      if (result) this.cancel();
      this.isLoading = false;
    },
    cancel() {
      this.$router.push("/app/admin/permissoes");
    },
    setFilterKeyword(text) {
      this.keywordFilter = text;
    },
    async requestAllKeywords() {
      this.isFetching = true;
      await this.getAllKeywordRequest();
      this.isFetching = false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";
.section {
  background-color: $color-1;
  padding-top: 20px;
}

.table-profiles {
  max-width: 81vw;
  @media screen and (max-width: $tablet) {
    max-width: 95vw;
  }
  th div {
    width: 110px;
    text-align: center;
  }
  .large-column {
    width: 220px;
    display: flex;
  }
  .centered-custom {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: calc(0.75em - 1px);
  }
}
</style>

<style lang="scss">
.table-profiles {
  th div {
    width: 110px;
    text-align: center;
    justify-content: center;
  }
  .vertical-middle {
    vertical-align: middle;
  }
}
</style>
